import { render, staticRenderFns } from "./FaceAgent.vue?vue&type=template&id=00802c6a"
import script from "./FaceAgent.vue?vue&type=script&lang=js"
export * from "./FaceAgent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports